var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 126,
    viewBox: "0 0 126 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.61 63.0067C108.609 72.0276 105.933 80.8454 100.92 88.3452C95.9071 95.845 88.7829 101.69 80.4482 105.141C72.1135 108.592 62.9427 109.494 54.0954 107.732C45.2482 105.971 37.1219 101.626 30.7442 95.2463C24.3664 88.8666 20.0237 80.739 18.2651 71.8912C16.5066 63.0435 17.4112 53.8729 20.8646 45.5393C24.318 37.2056 30.165 30.0831 37.6663 25.0726C45.1676 20.062 53.9863 17.3883 63.0071 17.3897",
    stroke: "#F7F8F8",
    strokeWidth: 23
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.909 55.0313C109.485 63.9133 108.392 73.0633 104.768 81.3241C101.143 89.5849 95.151 96.5856 87.5481 101.441C79.9453 106.296 71.0735 108.787 62.0546 108.6C53.0357 108.413 44.2748 105.556 36.8797 100.39C29.4847 95.2238 23.7877 87.9808 20.5091 79.5768C17.2305 71.1729 16.5176 61.9855 18.4605 53.1763C20.4034 44.3672 24.9149 36.3321 31.4245 30.087C37.9341 23.8419 46.1494 19.6674 55.0315 18.0913",
    stroke: "#F7F8F8",
    strokeWidth: 23
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.372 41.7769C107.569 49.7616 109.305 58.8118 108.359 67.7829C107.413 76.754 103.828 85.2431 98.0572 92.1768C92.2866 99.1104 84.5894 104.177 75.9392 106.736C67.289 109.295 58.0741 109.232 49.46 106.554C40.8458 103.876 33.2192 98.7036 27.5446 91.6911C21.87 84.6787 18.4023 76.141 17.5799 67.1577C16.7576 58.1744 18.6175 49.149 22.9246 41.2228C27.2317 33.2966 33.7925 26.8256 41.7772 22.6281",
    stroke: "#6EC4A1",
    strokeWidth: 23
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5795 24.5792C95.1784 29.4406 101.165 36.4461 104.782 44.7099C108.4 52.9737 109.485 62.1245 107.902 71.0053C106.319 79.8861 102.138 88.098 95.8871 94.6024C89.6367 101.107 81.5978 105.612 72.7871 107.547C63.9764 109.483 54.7896 108.763 46.3883 105.477C37.987 102.192 30.7487 96.4888 25.5886 89.0895C20.4286 81.6903 17.5785 72.927 17.3989 63.908C17.2193 54.8889 19.7181 46.0192 24.5795 38.4203",
    stroke: "#F7F8F8",
    strokeWidth: 23
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0001 17.348C72.0292 17.348 80.8556 20.0254 88.3631 25.0418C95.8705 30.0581 101.722 37.188 105.177 45.5298C108.632 53.8717 109.537 63.0508 107.775 71.9065C106.014 80.7621 101.666 88.8966 95.281 95.2811C88.8965 101.666 80.762 106.014 71.9064 107.775C63.0507 109.537 53.8716 108.633 45.5297 105.177C37.1879 101.722 30.058 95.8706 25.0417 88.3632C20.0254 80.8557 17.3479 72.0293 17.3479 63.0002",
    stroke: "#F7F8F8",
    strokeWidth: 23
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.70c09e2939e295cfaa2aadd81ddbbcc9.svg";
export { ForwardRef as ReactComponent };